import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { AlgoTravelPreferencesComponent } from './algo-travel-preferences.component';
import { ToastModule } from 'primeng';

@NgModule({
  imports: [VmeCommonModule, VmeDirectivesModule, VmePipesModule, ToastModule],
  declarations: [AlgoTravelPreferencesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [AlgoTravelPreferencesComponent],
})
export class AlgoTravelPreferencesModule {}
